import { fetchData } from "@utils/api";
import { APIMethods, ApiResponse } from "@typeDefinitions";
import { object } from "yup";
import {
  DietitianClinicListResource,
  dietitianClinicListResourceSchema,
} from "@client/resources/ClinicDietitianResource";

export const fetchClinicDietitian = async (
  id: number,
): Promise<ApiResponse<DietitianClinicListResource>> => {
  const response = await fetchData(
    `/dietitian/clinic/dietitians/${id}`,
    APIMethods.GET,
  );
  return await fetchClinicDietitianSchema.validate(response);
};

export type ClinicDietitianResponse = DietitianClinicListResource;

const fetchClinicDietitianSchema = object({
  data: dietitianClinicListResourceSchema.required(),
});
